var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "spnod-app"
    }
  }, [_c('div', {
    staticClass: "spnod-admin"
  }, [_c('div', {
    staticClass: "small-header",
    class: _vm.displayMenu ? 'between' : ''
  }, [(_vm.displayMenu) ? _c('Hamburger') : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.logoPath,
      "width": "100px"
    }
  }), _vm._v(" "), (_vm.displayMenu) ? _c('div', {
    attrs: {
      "id": "placeholder"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "spnod-page__admin"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSpinner),
      expression: "showSpinner"
    }],
    staticClass: "spnod-overlay"
  }, [_c('div', {
    staticClass: "loader page-loader"
  }, [_vm._v("Loading...")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8e355d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/App.vue
// module id = BDbL
// module chunks = 2